import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import VesselTypeCreateForm from '~/containers/vesselTypeCreate/vesselTypeCreate';

export class VesselTypeCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/settings/vesseltypes`}>
        <Button color="secondary">Cancel</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/settings/vesseltypes" backText="Vessel Types" title="Add vessel type" button={cancelButton} />
        <VesselTypeCreateForm />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(VesselTypeCreatePage));



// WEBPACK FOOTER //
// ./src/pages/vesselTypeCreate/vesselTypeCreate.jsx